import styled from "styled-components";

import {
    DefaultParagraphLargeFactory,
    DefaultParagraphMediumFactory,
} from "../core/Typograph/Typograph.Style";


export const VideoSlideCard = styled.div(({ theme }) => ({
    maxWidth: "360px",
    marginTop: "32px",
    [theme.breakpoint.lg()]: {
        marginTop: "0",
    },
}));

export const Link = styled.a(({ theme }) => ({
    color: theme.color.brandPrimary.light,
    lineHeight: "150%",
    padding: "16px 36px",
    border: `1px solid ${theme.color.brandPrimary.light}`,
    width: "100%",
    borderRadius: 500,
    display: "block",
    textAlign: "center",
    textDecoration: "none",
    fontSize: 14,
    fontWeight: 500,

    svg: {
        display: "none",
    },

    [theme.breakpoint.lg()]: {
        textDecoration: "underline",
        gap: 8,
        display: "flex",
        alignItems: "center",
        padding: 0,
        border: "none",
        fontSize: 16,
        fontWeight: 400,

        svg: {
            display: "block",
        },
    },
}));

export const Title = styled.h3(({ theme }) => ({
    ...DefaultParagraphLargeFactory({ theme }),
    marginBottom: "8px",
    fontWeight: 600,
}));

export const Paragraph = styled.p(({ theme }) => ({
    ...DefaultParagraphMediumFactory({ theme }),
    marginBottom: "32px",

    [theme.breakpoint.lg()]: {
        marginBottom: "8px",
    },
}));

export const Container = styled.div(({ theme }) => ({
    display: "none",

    [theme.breakpoint.lg()]: {
        display: "flex",
        justifyContent: "space-between",
        marginTop: 60,
        flexWrap: "wrap",
    },
}));